import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { FarrisContextMenuModule } from '@farris/ui-context-menu';
import { AngularDraggableModule } from '@farris/ui-draggable';
import { MessagerModule } from '@farris/ui-messager';
import { FarrisCommonModule } from '@farris/ui-common';
import { NotifyModule } from '@farris/ui-notify';
import { LoadingModule } from '@farris/ui-loading';
import { ModalModule } from '@farris/ui-modal';

import { IdeTabsComponent } from './ide-tabs.component';
import { IdeDraggeTabDirective } from './ide-dragge-tab.directive';

@NgModule({
  declarations: [
    IdeTabsComponent,
    IdeDraggeTabDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    FarrisCommonModule.forRoot(),
    MessagerModule.forRoot(),
    AngularDraggableModule,
    FarrisContextMenuModule,
    ModalModule.forRoot(),
    NotifyModule.forRoot(),
    LoadingModule.forRoot()
  ],
  exports: [
    IdeTabsComponent
  ]
})
export class IdeTabsModule { }
